import OrdersRoot from './Orders';

const OrdersList = () => import ( /* webpackChunkName: "orders" */ './OrdersList');
const OrderDetails = () => import ( /* webpackChunkName: "orders" */ './OrderDetails');

export default {
  path: '/orders',
  name: 'orders',
  redirect: '/orders/all',
  component: OrdersRoot,
  children: [{
      path: 'all',
      name: 'ordersAll',
      component: OrdersList
    }, {
      path: 'breakdown',
      name: 'ordersBreakdown',
      component: OrdersList
    }, {
      path: ':orderId/details',
      name: 'ordersDetails',
      component: OrderDetails,
      props: true
    },
    // {
    // path: 'purchases',
    // name: 'ordersPurchases',
    // redirect: '/orders/purchases/order-history',
    // component: OrdersList,
    // props: { isClientAdmin: true },
    // children: [{
    //   path: 'order-history',
    //   name: 'ordersPurchasesOrderhistory'
    // }, {
    //   path: 'default-address',
    //   name: 'ordersPurchasesDefaultaddress'
    // }, {
    //   path: 'payment-method',
    //   name: 'ordersPurchasesPaymentmethod'
    // }]
    // }
  ]
}